import { Box } from '@mui/material';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
export type SlidesProps<T> = {
  data: T[];
  navigation?: boolean;
  pagination?: boolean;
  allowTouchMove?: boolean;
  customComponent: (item: T, index: number) => React.ReactNode;
};
function Slider<T>({
  data,
  navigation = false,
  pagination = false,
  allowTouchMove = false,
  customComponent
}: SlidesProps<T>) {
  return <Box sx={{
    width: '100%',
    minHeight: {
      xs: 200,
      md: 445
    },
    position: 'relative',
    '& .swiper-button-next': {
      width: '48px',
      height: '48px',
      background: 'rgba(0, 0, 0, 0.4)',
      borderRadius: '8px'
    },
    '& .swiper-button-prev': {
      width: '48px',
      height: '48px',
      background: 'rgba(0, 0, 0, 0.4)',
      borderRadius: '8px'
    },
    '& .swiper-button-prev:after': {
      fontSize: '25px',
      fontWeight: 'bold',
      color: 'white'
    },
    '& .swiper-button-next:after': {
      fontSize: '25px',
      fontWeight: 'bold',
      color: 'white'
    },
    '& .swiper-pagination': {
      width: '48px',
      height: '32px',
      position: 'absolute',
      right: '26px',
      top: '26px',
      color: 'white',
      background: 'rgba(0, 0, 0, 0.4)',
      borderRadius: '16px',
      paddingTop: '4px'
    }
  }} data-sentry-element="Box" data-sentry-component="Slider" data-sentry-source-file="Slider.tsx">
      <Swiper slidesPerView={'auto'} pagination={pagination ? {
      clickable: true,
      type: 'fraction'
    } : false} navigation={navigation} modules={[Pagination, Navigation]} scrollbar={{
      draggable: true
    }}
    // preventInteractionOnTransition={false}
    // preventClicksPropagation={false}
    // noSwiping={false}
    allowTouchMove={allowTouchMove}
    // touchStartPreventDefault={false}
    // touchStartForcePreventDefault={false}
    // touchMoveStopPropagation={true}
    data-sentry-element="Swiper" data-sentry-source-file="Slider.tsx">
        {data.map((item, idx) => {
        return <SwiperSlide key={idx}>
              {({
            isActive
          }) => isActive ? customComponent(item, idx) : null}
            </SwiperSlide>;
      })}
      </Swiper>
    </Box>;
}
export default Slider;